import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a72c22a")

_pushScopeId("data-v-2a72c22a")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-8" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_8 = {
  key: 0,
  class: "card mb-5 card-p"
}
const _hoisted_9 = { class: "card-header-title mb-5 p-0 fs-5 text-color-default" }
const _hoisted_10 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_11 = { class: "d-flex flex-wrap align-items-center name-area" }
const _hoisted_12 = {
  key: 1,
  class: "card mb-5 card-p"
}
const _hoisted_13 = { class: "card-header-title mb-5 p-0 fs-5 text-color-default" }
const _hoisted_14 = { class: "summary-list" }
const _hoisted_15 = { "data-tooltip": "Tooltip help here!" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { "data-tooltip": "Tooltip help here!" }
const _hoisted_21 = { "data-tooltip": "Tooltip help here!" }
const _hoisted_22 = {
  key: 2,
  class: "card mb-5 card-p"
}
const _hoisted_23 = { class: "card-header-title mb-5 p-0 fs-5 text-color-default" }
const _hoisted_24 = {
  key: 3,
  class: "card mb-5 card-p"
}
const _hoisted_25 = { class: "card-header-title mb-5 p-0 fs-5 text-color-default" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomerDashboard = _resolveComponent("CustomerDashboard")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_CustomerOrders = _resolveComponent("CustomerOrders")!
  const _component_Addresses = _resolveComponent("Addresses")!
  const _component_EndUser = _resolveComponent("EndUser")!
  const _component_CupAgreementProducts = _resolveComponent("CupAgreementProducts")!
  const _component_Subsidiary = _resolveComponent("Subsidiary")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_CustomerDetailContentLoader = _resolveComponent("CustomerDetailContentLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CustomerCart = _resolveComponent("CustomerCart")!
  const _component_CustomerFavoriteProducts = _resolveComponent("CustomerFavoriteProducts")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
            class: "attribute-tabs customer-details-tabs",
            "tab-position": 'top'
          }, {
            default: _withId(() => [
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('message.DASHBOARD'),
                name: "first"
              }, {
                default: _withId(() => [
                  _createVNode(_component_CustomerDashboard, { uuid: _ctx.uuid }, null, 8, ["uuid"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('message.ORDERS'),
                name: "second"
              }, {
                default: _withId(() => [
                  (_ctx.customerOrdersTab == true)
                    ? (_openBlock(), _createBlock(_component_CustomerOrders, { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_tab_pane, {
                label: _ctx.$t('message.ADDRESSES'),
                name: "third"
              }, {
                default: _withId(() => [
                  (_ctx.customerAddressTab == true)
                    ? (_openBlock(), _createBlock(_component_Addresses, {
                        key: 0,
                        customer: _ctx.customer
                      }, null, 8, ["customer"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.customer?.site?.type != 'B2C' && _ctx.customer?.user?.roles != 'manager')
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 0,
                    label: _ctx.$t('message.USERS'),
                    name: "fourth"
                  }, {
                    default: _withId(() => [
                      (_ctx.endUsersTab == true)
                        ? (_openBlock(), _createBlock(_component_EndUser, {
                            key: 0,
                            customerAbilities: _ctx.customerAbilities,
                            customer: _ctx.customer
                          }, null, 8, ["customerAbilities", "customer"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.customer?.in_cup_agreement == 1)
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 1,
                    label: `${_ctx.$t('message.CUP_AGREEMENT')} ${_ctx.$t('message.PRODUCT')}`,
                    name: "fifth"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_CupAgreementProducts, { cup_agreement_products: _ctx.cup_agreement_products }, null, 8, ["cup_agreement_products"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.customer?.site?.type != 'B2C' && _ctx.customer?.user?.roles != 'manager' && _ctx.provider == 'dankoff')
                ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: 2,
                    label: _ctx.$t('message.SUBSIDIARY'),
                    name: "sixth"
                  }, {
                    default: _withId(() => [
                      (_ctx.subsidiaryTab == true)
                        ? (_openBlock(), _createBlock(_component_Subsidiary, {
                            key: 0,
                            customer: _ctx.customer
                          }, null, 8, ["customer"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_CustomerDetailContentLoader, { key: 0 }))
          : (_openBlock(), _createBlock("div", _hoisted_7, [
              (_ctx.customer)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("header", _hoisted_9, _toDisplayString(`${_ctx.$t('message.CUSTOMER')} ${_ctx.$t('message.NAME')}`), 1),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", {
                          class: "name-avatar",
                          style: 'background:' + _ctx.companyLogo(_ctx.customer?.user?.name)?.color
                        }, _toDisplayString(_ctx.companyLogo(_ctx.customer?.user?.name)?.name), 5),
                        _createVNode("h3", null, _toDisplayString(_ctx.customer.user?.name), 1)
                      ]),
                      _createVNode(_component_router_link, {
                        class: "view-all-details btn btn-custom fs-7",
                        to: {
                                    name: 'edit_customer',
                                    params: { uuid: _ctx.customer?.uuid }
                                }
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.EDIT')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.customer)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_InnerLoader, {
                      loading: _ctx.loader,
                      innerLoading: true
                    }, null, 8, ["loading"]),
                    _createVNode("header", _hoisted_13, _toDisplayString(_ctx.$t('message.CUSTOMER_INFORMATION')), 1),
                    _createVNode("ul", _hoisted_14, [
                      _createVNode("li", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('message.EMAIL')), 1),
                        _createVNode(_component_el_tooltip, {
                          class: "item",
                          effect: "dark",
                          content: _ctx.customer?.user?.email,
                          placement: "top"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.customer?.user?.email), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _createVNode("li", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('message.PHONE_NUMBER')), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.customer?.phone_number ? _ctx.customer?.phone_number : 'N/A'), 1)
                      ]),
                      _createVNode("li", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('message.STATUS')), 1),
                        (_ctx.customer?.user?.status == 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
                      ]),
                      _createVNode("li", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('message.CREATED_AT')), 1),
                        (_ctx.customer?.created_at)
                          ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.customer?.created_at), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("li", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('message.SHIPPING_METHODS')), 1),
                        (_ctx.customer?.customer_to_shipping_methods == null || _ctx.customer?.customer_to_shipping_methods.length == 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_19, [
                              _createVNode(_component_el_tooltip, {
                                class: "item",
                                effect: "dark",
                                content: _ctx.$t('message.NO_SHIPPING_METHOD_FOUND'),
                                placement: "top"
                              }, {
                                default: _withId(() => [
                                  _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('message.NO_SHIPPING_METHOD_FOUND')), 1)
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customer?.customer_to_shipping_methods, (shipping) => {
                          return (_openBlock(), _createBlock("span", {
                            key: shipping.id
                          }, [
                            _createVNode(_component_el_tooltip, {
                              class: "item",
                              effect: "dark",
                              content: _ctx.shippingMethodName(shipping),
                              placement: "top"
                            }, {
                              default: _withId(() => [
                                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.shippingMethodName(shipping)), 1)
                              ]),
                              _: 2
                            }, 1032, ["content"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.customer)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode("header", _hoisted_23, _toDisplayString(_ctx.$t('message.ACTIVE_CART')), 1),
                    _createVNode(_component_CustomerCart, {
                      cartLists: _ctx.customer?.cart,
                      customer: _ctx.customer
                    }, null, 8, ["cartLists", "customer"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.customer)
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _createVNode("header", _hoisted_25, _toDisplayString(_ctx.$t('message.CUSTOMER_FAVORITE_PRODUCTS')), 1),
                    _createVNode(_component_CustomerFavoriteProducts, { customer: _ctx.customer }, null, 8, ["customer"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
})